import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { DevicePickerComponent, NormalizedDeviceData } from '@devices';

import { WidgetConnectedDevices } from '../../../models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DevicePickerComponent],
  selector: 'avs-connected-devices-options',
  templateUrl: './connected-devices-options.component.html',
})
export class ConnectedDevicesOptionsComponent {
  changed = output<Partial<WidgetConnectedDevices> | null>();
  config = input<WidgetConnectedDevices>();

  protected assignedDevices = computed(() =>
    // No need to fetch full device data for the options component, as we only need the IDs to pre-select assigned devices in the picker
    (this.config()?.deviceIds ?? []).map(id => ({ id } as NormalizedDeviceData)),
  );

  protected onDevicesChange(devices: NormalizedDeviceData[]) {
    this.changed.emit(devices.length ? { deviceIds: devices.map(device => device.id) } : null);
  }
}
